import { useQuery, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { refetchUserOnError } from 'utils/refetchUserOnError';

export type NotificationPreferences = {
  email: {
    mentions: boolean;
    assignments: boolean;
    statusChanges: boolean;
    comments: boolean;
    dueDates: boolean;
    projectInvites: boolean;
  };
  inApp: {
    mentions: boolean;
    assignments: boolean;
    statusChanges: boolean;
    comments: boolean;
    dueDates: boolean;
    projectInvites: boolean;
  };
};

type PreferencesResponse = {
  preferences: NotificationPreferences;
};

const getPreferences = async (): Promise<PreferencesResponse> => {
  const { data } = await customAxios.get<PreferencesResponse>(
    '/notification-preferences'
  );
  return data;
};

export const useGetNotificationPreferences = () => {
  const queryClient = useQueryClient();

  return useQuery<PreferencesResponse>({
    queryKey: ['notification-preferences'],
    queryFn: getPreferences,
    onError: (err) => {
      refetchUserOnError(err, queryClient);
    },
  });
};
